import { Navigate, useNavigate } from "react-router-dom";
import {
  Cell,
  List,
  Placeholder,
  Section,
  Spinner,
} from "@telegram-apps/telegram-ui";

import { getDefaultPath } from "../access";
import { useAppData } from "../AppData";
import type { OperationCategory } from "../types";
import { OperationForm } from "./OperationForm";

type Props = {
  category: OperationCategory;
  header: string;
};

export function CategoryTab({ category, header }: Props) {
  const navigate = useNavigate();
  const { me, operations, loading, error } = useAppData();

  if (loading) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }

  if (error) {
    return <Placeholder header="Ошибка" description={error} />;
  }

  const ops = operations.filter((op) => op.category === category);

  // Нет ни одной операции в категории — раздел скрыт из меню, сюда не пускаем.
  if (ops.length === 0) {
    return <Navigate to={getDefaultPath(me, operations)} replace />;
  }

  // Единственная операция в разделе — открываем её сразу, без промежуточного
  // списка. Форма рендерится как корень таба: нижнее меню даёт TabsLayout,
  // кнопки «Назад» нет. key пересоздаёт форму при переключении между табами
  // (React переиспользует этот же компонент под разные категории).
  if (ops.length === 1) {
    return <OperationForm key={ops[0].id} opId={ops[0].id} asTabRoot />;
  }

  return (
    <div className="page page--with-nav">
      <List>
        <Section header={header}>
          {ops.map((op) => (
            <Cell
              key={op.id}
              subtitle={op.description}
              multiline
              onClick={() => navigate(`/op/${op.id}`)}
              style={{ cursor: "pointer" }}
            >
              {op.title}
            </Cell>
          ))}
        </Section>
      </List>
    </div>
  );
}
